import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { Hotel } from "../../types/hotel.d";
import { useNavigate } from "react-router-dom";
import HotelService from "../../api/hotelService";

interface EditHotelProps {
  hotel: Hotel;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSave: (updatedHotel: Hotel) => void;
}

const EditHotel: React.FC<EditHotelProps> = ({
  hotel,
  isOpen,
  setIsOpen,
  onSave,
}) => {
  const [hotelName, setHotelName] = useState<string>(hotel.name);
  const [rooms, setRooms] = useState<number | string>(hotel.maxUnitsCapacity);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    setHotelName(hotel.name);
    setRooms(hotel.maxUnitsCapacity);
    setError(null);
  }, [hotel]);

  const handleSave = async () => {
    if (!hotelName.trim() || Number(rooms) <= 0) {
      setError(
        "Veuillez entrer un nom valide et un nombre de chambres supérieur à 0."
      );
      return;
    }

    try {
      await HotelService.updateHotel(hotel.id, {
        name: hotelName,
        maxUnitsCapacity: Number(rooms),
      });
      onSave({ ...hotel, name: hotelName, maxUnitsCapacity: Number(rooms) });
      setIsOpen(false);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'hôtel:", error);
      setError("La mise à jour de l'hôtel a échoué. Veuillez réessayer.");
    }
  };

  const handleViewContacts = () => {
    navigate("/contacts", { state: { hotelId: hotel.id } });
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle align="center">Modifier l'hôtel</DialogTitle>
      <DialogContent>
        <TextField
          label="Nom"
          fullWidth
          value={hotelName}
          onChange={(e) => setHotelName(e.target.value)}
          required
          sx={{ mt: 2 }}
        />
        <TextField
          label="Chambres"
          type="number"
          fullWidth
          value={rooms}
          onChange={(e) => {
            const value = Number(e.target.value);
            if (value < 0) {
              return;
            }
            setRooms(e.target.value);
          }}
          required
          sx={{ mt: 2 }}
        />
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
        <Button
          onClick={handleViewContacts}
          color="primary"
          variant="outlined"
          sx={{ mt: 2 }}
        >
          Gérer les contacts
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsOpen(false)}>Annuler</Button>
        <Button onClick={handleSave} variant="contained">
          Sauvegarder
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditHotel;
